export const DEFAULT_MODEL = 'default';

const NAMED_GRAPH_CONTEXT = 'tag:stardog:api:context';
export const ALL_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:all`;
export const DEFAULT_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:default`;
export const LOCAL_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:local`;
export const NAMED_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:named`;
export const VIRTUAL_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:virtual`;
export const SCHEMA_NAMED_GRAPH_IRI = `${NAMED_GRAPH_CONTEXT}:schema`;
export const SPECIAL_NAMED_GRAPH_IRIS = [
  ALL_NAMED_GRAPH_IRI,
  DEFAULT_NAMED_GRAPH_IRI,
  LOCAL_NAMED_GRAPH_IRI,
  NAMED_NAMED_GRAPH_IRI,
  VIRTUAL_NAMED_GRAPH_IRI,
];

export const ALIASES_GRAPH = 'tag:stardog:api:graph:aliases';
export const SQL_SCHEMA_GRAPH = 'tag:stardog:api:sql:schema';

export const RULE_SPARQL_RULE_IRI = 'tag:stardog:api:rule:SPARQLRule';
export const RULE_CONTENT_IRI = 'tag:stardog:api:rule:content';

export const OWL_IRI = 'http://www.w3.org/2002/07/owl#';
export const OWL_CLASS_IRI = `${OWL_IRI}Class`;
export const OWL_DATATYPE_PROPERTY_IRI = `${OWL_IRI}DatatypeProperty`;
export const OWL_OBJECT_PROPERTY_IRI = `${OWL_IRI}ObjectProperty`;
export const OWL_THING_IRI = `${OWL_IRI}Thing`;

export const RDF_IRI = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
export const RDF_TYPE_IRI = `${RDF_IRI}type`;

export const RDF_PROPERTY_IRI = `${RDF_IRI}Property`;
export const RDFS_IRI = 'http://www.w3.org/2000/01/rdf-schema#';
export const RDFS_CLASS_IRI = `${RDFS_IRI}Class`;
export const RDFS_COMMENT_IRI = `${RDFS_IRI}comment`;
export const RDFS_DOMAIN_IRI = `${RDFS_IRI}domain`;
export const RDFS_LABEL_IRI = `${RDFS_IRI}label`;
export const RDFS_RANGE_IRI = `${RDFS_IRI}range`;
export const RDFS_SUB_CLASS_OF_IRI = `${RDFS_IRI}subClassOf`;
export const RDFS_SUB_PROPERTY_OF_IRI = `${RDFS_IRI}subPropertyOf`;

export const SCHEMA_ORG_IRI = 'https://schema.org/';
export const SCHEMA_ORG_CLASS_IRI = `${SCHEMA_ORG_IRI}Class`;
export const SCHEMA_ORG_DOMAIN_INCLUDES_IRI = `${SCHEMA_ORG_IRI}domainIncludes`;
export const SCHEMA_ORG_RANGE_INCLUDES_IRI = `${SCHEMA_ORG_IRI}rangeIncludes`;
export const SCHEMA_ORG_SUPERSEDED_BY_IRI = `${SCHEMA_ORG_IRI}supersededBy`;
export const SCHEMA_ORG_DATE_PUBLISHED_IRI = `${SCHEMA_ORG_IRI}datePublished`;

export const SCHEMA_ORG_HTTP_IRI = 'http://schema.org/';
export const SCHEMA_ORG_HTTP_CLASS_IRI = `${SCHEMA_ORG_HTTP_IRI}Class`;
export const SCHEMA_ORG_HTTP_DOMAIN_INCLUDES_IRI = `${SCHEMA_ORG_HTTP_IRI}domainIncludes`;
export const SCHEMA_ORG_HTTP_RANGE_INCLUDES_IRI = `${SCHEMA_ORG_HTTP_IRI}rangeIncludes`;
export const SCHEMA_ORG_HTTP_SUPERSEDED_BY_IRI = `${SCHEMA_ORG_HTTP_IRI}supersededBy`;

export const SKOS_IRI = 'http://www.w3.org/2004/02/skos/core#';
export const SKOS_CONCEPT_IRI = `${SKOS_IRI}Concept`;
export const SKOS_DEFINITION_IRI = `${SKOS_IRI}definition`;
export const SKOS_PREF_LABEL_IRI = `${SKOS_IRI}prefLabel`;

export const STARDOG_API_IRI = `tag:stardog:api:`;

export const XSD_IRI = 'http://www.w3.org/2001/XMLSchema#';

export const XSD_ANY_IRI_IRI = `${XSD_IRI}anyURI`;
export const XSD_BASE_64_BINARY_IRI = `${XSD_IRI}base64Binary`;
export const XSD_BOOLEAN_IRI = `${XSD_IRI}boolean`;
export const XSD_DATE_TIME_IRI = `${XSD_IRI}dateTime`;
export const XSD_DATE_IRI = `${XSD_IRI}date`;
export const XSD_DECIMAL_IRI = `${XSD_IRI}decimal`;
export const XSD_DOUBLE_IRI = `${XSD_IRI}double`;
export const XSD_DURATION_IRI = `${XSD_IRI}duration`;
export const XSD_FLOAT_IRI = `${XSD_IRI}float`;
export const XSD_G_DAY_IRI = `${XSD_IRI}gDay`;
export const XSD_G_MONTH_DAY_IRI = `${XSD_IRI}gMonthDay`;
export const XSD_G_MONTH_IRI = `${XSD_IRI}gMonth`;
export const XSD_G_YEAR_MONTH_IRI = `${XSD_IRI}gYearMonth`;
export const XSD_G_YEAR_IRI = `${XSD_IRI}gYear`;
export const XSD_HEX_BINARY_IRI = `${XSD_IRI}hexBinary`;
export const XSD_INTEGER_IRI = `${XSD_IRI}integer`;
export const XSD_NOTATION_IRI = `${XSD_IRI}NOTATION`;
export const XSD_Q_NAME_IRI = `${XSD_IRI}QName`;
export const XSD_STRING_IRI = `${XSD_IRI}string`;
export const XSD_TIME_IRI = `${XSD_IRI}time`;

export const DATATYPE_IRIS = [
  XSD_ANY_IRI_IRI,
  XSD_BASE_64_BINARY_IRI,
  XSD_BOOLEAN_IRI,
  XSD_DATE_TIME_IRI,
  XSD_DATE_IRI,
  XSD_DECIMAL_IRI,
  XSD_DOUBLE_IRI,
  XSD_DURATION_IRI,
  XSD_FLOAT_IRI,
  XSD_G_DAY_IRI,
  XSD_G_MONTH_DAY_IRI,
  XSD_G_MONTH_IRI,
  XSD_G_YEAR_MONTH_IRI,
  XSD_G_YEAR_IRI,
  XSD_HEX_BINARY_IRI,
  XSD_INTEGER_IRI,
  XSD_NOTATION_IRI,
  XSD_Q_NAME_IRI,
  XSD_STRING_IRI,
  XSD_TIME_IRI,
];

export const CLASS_IRIS = [
  OWL_CLASS_IRI,
  RDFS_CLASS_IRI,
  SCHEMA_ORG_CLASS_IRI,
  SCHEMA_ORG_HTTP_CLASS_IRI,
  SKOS_CONCEPT_IRI,
];

export const DESCRIPTION_IRIS = [RDFS_COMMENT_IRI, SKOS_DEFINITION_IRI];

export const LABEL_IRIS = [RDFS_LABEL_IRI, SKOS_PREF_LABEL_IRI];

export const DESIGNER_COLOR_ID_IRI = 'tag:stardog:designer:colorId';
export const DESIGNER_EXISTS_IRI = 'tag:stardog:designer:exists';
export const DESIGNER_RULE_DATA_IRI = 'tag:stardog:designer:rule:data';
export const DESIGNER_RULE_CONTENT_IRI = 'tag:stardog:designer:rule:content';

export const DATA_SOURCE_PREFIX = 'data-source://';
export const REGISTRY_PREFIX = 'http://system.stardog.com/registry/';
export const METADATA_REGISTRY_DATA_SOURCE_NAME_IRI = `${REGISTRY_PREFIX}jdbcDataSourceMetadata/name`;
export const METADATA_REGISTRY_DATA_SOURCE_TABLE_IRI = `${REGISTRY_PREFIX}jdbcDataSourceMetadata/table`;
export const METADATA_REGISTRY_TABLE_CATALOG_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/catalog`;
export const METADATA_REGISTRY_TABLE_SCHEMA_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/schema`;
export const METADATA_REGISTRY_TABLE_NAME_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/tableName`;
export const METADATA_REGISTRY_TABLE_TYPE_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/tableType`;
export const METADATA_REGISTRY_TABLE_TYPE_INDEX_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/tableType/INDEX`;
export const METADATA_REGISTRY_TABLE_TYPE_SEQUENCE_IRI = `${REGISTRY_PREFIX}jdbcDataSource/table/tableType/SEQUENCE`;

// suggestions attribute matcher endpoint
export const SUGGESTIONS_PREFIX_IRI = 'tag:stardog:api:match:';
export const SUGGESTIONS_AUTO_CREATE_IRI = `${SUGGESTIONS_PREFIX_IRI}AutoCreate`;
export const SUGGESTIONS_CONFIGURATION_IRI = `${SUGGESTIONS_PREFIX_IRI}configuration`;
export const SUGGESTIONS_CSV_QUOTE_IRI = `${SUGGESTIONS_PREFIX_IRI}csvQuote`;
export const SUGGESTIONS_CSV_SEPARATOR_IRI = `${SUGGESTIONS_PREFIX_IRI}csvSeparator`;
export const SUGGESTIONS_HAS_KEY = `${SUGGESTIONS_PREFIX_IRI}hasKey`;
export const SUGGESTIONS_HAS_LABEL = `${SUGGESTIONS_PREFIX_IRI}hasLabel`;
export const SUGGESTIONS_HAS_PROPERTY_MATCH_IRI = `${SUGGESTIONS_PREFIX_IRI}hasPropertyMatch`;
export const SUGGESTIONS_KEY_MATCH = `${SUGGESTIONS_PREFIX_IRI}KeyMatch`;
export const SUGGESTIONS_KEY_SCORE = `${SUGGESTIONS_PREFIX_IRI}keyScore`;
export const SUGGESTIONS_KEY_SOURCE = `${SUGGESTIONS_PREFIX_IRI}keySource`;
export const SUGGESTIONS_LABEL_MATCH = `${SUGGESTIONS_PREFIX_IRI}LabelMatch`;
export const SUGGESTIONS_LABEL_SCORE = `${SUGGESTIONS_PREFIX_IRI}labelScore`;
export const SUGGESTIONS_LABEL_SOURCE = `${SUGGESTIONS_PREFIX_IRI}labelSource`;
export const SUGGESTIONS_MATCH_SCORE_IRI = `${SUGGESTIONS_PREFIX_IRI}matchScore`;
export const SUGGESTIONS_MODEL_IRI = `${SUGGESTIONS_PREFIX_IRI}model`;
export const SUGGESTIONS_PROPERTY_MATCH_TYPE_IRI = `${SUGGESTIONS_PREFIX_IRI}PropertyMatch`;
export const SUGGESTIONS_SOURCE_DATA_IRI = `${SUGGESTIONS_PREFIX_IRI}sourceData`;
export const SUGGESTIONS_SOURCE_IRI = `${SUGGESTIONS_PREFIX_IRI}source`;
export const SUGGESTIONS_SOURCE_NAME_IRI = `${SUGGESTIONS_PREFIX_IRI}sourceName`;
export const SUGGESTIONS_SOURCE_QUERY_IRI = `${SUGGESTIONS_PREFIX_IRI}sourceQuery`;
export const SUGGESTIONS_SOURCE_TABLE_IRI = `${SUGGESTIONS_PREFIX_IRI}sourceTable`;
export const SUGGESTIONS_SQL_QUOTING_IRI = `${SUGGESTIONS_PREFIX_IRI}sqlQuoting`;
export const SUGGESTIONS_TARGET_IRI = `${SUGGESTIONS_PREFIX_IRI}target`;
export const SUGGESTIONS_TARGET_NAMESPACE_IRI = `${SUGGESTIONS_PREFIX_IRI}targetNamespace`;
export const SUGGESTIONS_TARGET_PROPERTY_TYPE = `${SUGGESTIONS_PREFIX_IRI}targetPropertyType`;
export const SUGGESTIONS_TARGET_TYPE_IRI = `${SUGGESTIONS_PREFIX_IRI}targetType`;
export const SUGGESTIONS_TYPE_MATCH_IRI = `${SUGGESTIONS_PREFIX_IRI}TypeMatch`;

export const DESIGNER_RULE_INVALID_IRI = 'tag:stardog:designer:rule:invalid';
